
export default
  name: 'stylesheet-v2'
  render: (h) ->    
    h('style', { attrs: { id: 'stylesheet-v2' } }, @css)  
  computed: 
    css: ->
      try
        return require("@/assets/style-v2.css")
      catch e
        return ''  
